export default { sha: '03348279e3118a0c45698c3940d0c70f4365982a', buildNumber: 'undefined' }
